import { APICore } from "./apiCore";

const api = new APICore()

function listUneTypes(params: any): any {
    const baseUrl = "/une-types"
    return api.get(baseUrl, params)
}

function listUneTouristTypes(params: any): any {
    const baseUrl = "/une-tourist-types"
    return api.get(baseUrl, params)
}

function listCuisineTypes(params: any): any {
    const baseUrl = "/cuisine-types"
    return api.get(baseUrl, params)
}

function listClientTypes(params: any): any {
    const baseUrl = "/client-types"
    return api.get(baseUrl, params)
}

export { listUneTypes, listUneTouristTypes, listCuisineTypes, listClientTypes }
